import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import {
  addTariff,
  clearAddTariffState,
} from '../../Redux/Slicers/Tariff/AddTariffSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateTariffState,
  updateTariff,
} from '../../Redux/Slicers/Tariff/UpdateTariffSlicer';
import ButtonField from '../../Components/Button/ButtonField';
import IconButtonField from '../../Components/Button/IconButtonField';
import SvgIcon from '@mui/material/SvgIcon';
import { Cancel } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { ITariffList } from './ITariff';

interface TariffFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const MasterForm: FunctionComponent<TariffFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { updateableDate } = useAppSelector((state) => state.UpdateTariff);
  const { data: ParkingType } = useAppSelector((state) => state?.ParkingType);
  const [parkingSlots, setParkingSlots] = useState<any>({});
  const [selectedParkingTypes, setSelectedParkingTypes] = useState<string[]>(
    []
  );
  const { pathname } = location;
  const pathnameParts = location.pathname.split('/');
  const id = pathnameParts[pathnameParts.length - 1];

  const initialValues = updateableDate
    ? {
        tariffName: updateableDate.tariffName,
        pricing: updateableDate.pricing,
        parkingTypes: updateableDate.pricing
          .map((item: any) => {
            const type = ParkingType?.response?.data?.find(
              (pt: any) => pt._id === item.parking_type_id
            );
            return type?.name?.toLowerCase() || ''; // Ensure to return a string
          })
          .filter((name: string) => name !== ''), // Filter out empty strings
      }
    : {
        tariffName: '',
        pricing: [],
        parkingTypes: [],
      };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      parkingTypes: Yup.array()
        .min(1, 'At least one parking type must be selected')
        .required('Required'),
      tariffName: Yup.string().required('Tariff name is required'),
      //     pricing: Yup.array().of(
      //       Yup.object().shape({
      //         slab: Yup.array().of(
      //           Yup.object().shape({
      //             min_time_minutes: Yup.number()
      //               .required('Min time is required')
      //               .min(0, 'Min time must be at least 0'),
      //             max_time_minutes: Yup.number()
      //               .required('Max time is required')
      //               .min(Yup.ref('min_time_minutes'), 'Max time must be greater than min time'),
      //             amount: Yup.number()
      //               .required('Amount is required')
      //               .min(0, 'Amount must be at least 0'),
      //           })
      //         ),
      //   }),
      // )
    }),
    onSubmit: (value) => {
      const pricing = Object.keys(parkingSlots).map((key) => ({
        parking_type_id:
          ParkingType?.response?.data?.find(
            (item: any) => item?.name.toLowerCase() === key
          )?._id || '',
        slab: parkingSlots[key].map((slot: any) => ({
          min_time_minutes: parseInt(slot.min_time_minutes, 10),
          max_time_minutes: parseInt(slot.max_time_minutes, 10),
          amount: parseInt(slot.amount, 10),
        })),
      }));

      const tariff = {
        ...value,
        pricing,
      };

      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(updateTariff({ ...tariff, id: updateableDate._id }));
      } else {
        dispatch(addTariff({ location_id: id, ...tariff }));
      }
    },
  });

  useEffect(() => {
    if (updateableDate && ParkingType?.response?.data) {
      const dd = ParkingType?.response?.data;
      const initialParkingSlots = updateableDate.pricing.reduce(
        (acc: any, item: any) => {
          const parkingType: any = dd.find(
            (type: any) => type._id === item.parking_type_id
          );
          if (parkingType) {
            const key = parkingType?.name.toLowerCase();
            acc[key] = item.slab.map((slot: any) => ({
              min_time_minutes: slot.min_time_minutes?.toString(),
              max_time_minutes: slot.max_time_minutes?.toString(),
              amount: slot.amount?.toString(),
            }));
          }
          return acc;
        },
        {}
      );
      setParkingSlots(initialParkingSlots);
      setSelectedParkingTypes(Object.keys(initialParkingSlots));
    }
    props.masterForm(formik);
    return () => {
      dispatch(clearAddTariffState());
      dispatch(clearUpdateTariffState());
      formik.resetForm();
    };
  }, [updateableDate, ParkingType]);

  const addParkingSlot = (slotType: string) => {
    setParkingSlots({
      ...parkingSlots,
      [slotType]: [
        ...(parkingSlots[slotType] || []),
        { min_time_minutes: '', max_time_minutes: '', amount: '' },
      ],
    });
  };

  const handleParkingChange = (
    index: number,
    key: string,
    value: any,
    slotType: string
  ) => {
    const updatedSlots = [...parkingSlots[slotType]];
    updatedSlots[index][key] = value;
    setParkingSlots({
      ...parkingSlots,
      [slotType]: updatedSlots,
    });
  };

  const removeParkingSlot = (index: number, slotType: string) => {
    const updatedSlots = [...parkingSlots[slotType]];
    updatedSlots.splice(index, 1);
    setParkingSlots({
      ...parkingSlots,
      [slotType]: updatedSlots,
    });
  };

  const form = ParkingType?.response?.data;
  if (!form) {
    console.log('data not found');
  }

  const formHeading: { [key: string]: string } = form?.reduce(
    (acc: any, item: any) => {
      const key = item.name.toLowerCase();
      acc[key] =
        item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase();
      return acc;
    },
    {}
  );
  // const getFieldError = (
  //   index: number,
  //   key: string
  // ): string | undefined => {
  //   const pricingErrors = formik.errors.pricing;
  //   console.log(pricingErrors);

  //   if (Array.isArray(pricingErrors)) {
  //     const slabErrors = pricingErrors[index]
  //     if (Array.isArray(slabErrors)) {
  //       return slabErrors[index]?.[key];
  //     }
  //   }
  //   return undefined;
  // };
  return (
    <form
      className="master_form"
      onSubmit={formik.handleSubmit}
      autoComplete="off">
      <TextInputField
        fullWidth
        id="tariffName"
        name="tariffName"
        label="Tariff Name"
        value={formik.values.tariffName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        helperText={formik.touched.tariffName && formik.errors.tariffName}
        error={formik.touched.tariffName && Boolean(formik.errors.tariffName)}
      />

      <Autocomplete
        multiple
        options={Object.keys(formHeading)}
        getOptionLabel={(option) => formHeading[option]}
        value={selectedParkingTypes}
        onChange={(event, newValue) => {
          formik.setFieldValue('parkingTypes', newValue);

          setSelectedParkingTypes(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Parking Type"
            placeholder="Select parking types"
            error={
              formik.touched.parkingTypes && Boolean(formik.errors.parkingTypes)
            }
            helperText={
              formik.touched.parkingTypes && formik.errors.parkingTypes
            }
          />
        )}
      />

      {selectedParkingTypes.map((selectedParkingType) => (
        <div
          key={selectedParkingType}
          className="parking-column">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}>
            <h3>{formHeading[selectedParkingType]}</h3>
            <ButtonField
              className="add_button"
              type="button"
              onClick={() => addParkingSlot(selectedParkingType)}>
              Add
            </ButtonField>
          </div>
          {parkingSlots[selectedParkingType] &&
            parkingSlots[selectedParkingType].map(
              (slot: any, index: number) => (
                <div
                  key={index}
                  className="parking-slot">
                  <TextInputField
                    sx={{ marginRight: '5px', marginBottom: '5px' }}
                    id={`${selectedParkingType}_min_time_${index}`}
                    name={`${selectedParkingType}_min_time_${index}`}
                    label="Min"
                    value={slot.min_time_minutes}
                    onChange={(e) =>
                      handleParkingChange(
                        index,
                        'min_time_minutes',
                        e.target.value,
                        selectedParkingType
                      )
                    }
                  />

                  <TextInputField
                    sx={{ marginRight: '5px' }}
                    id={`${selectedParkingType}_max_time_${index}`}
                    name={`${selectedParkingType}_max_time_${index}`}
                    label="Max"
                    value={slot.max_time_minutes}
                    onChange={(e) =>
                      handleParkingChange(
                        index,
                        'max_time_minutes',
                        e.target.value,
                        selectedParkingType
                      )
                    }
                    onBlur={formik.handleBlur}
                  />

                  <TextInputField
                    sx={{ marginRight: '5px' }}
                    id={`${selectedParkingType}_amount_${index}`}
                    name={`${selectedParkingType}_amount_${index}`}
                    label="Amount"
                    value={slot.amount}
                    onChange={(e) =>
                      handleParkingChange(
                        index,
                        'amount',
                        e.target.value,
                        selectedParkingType
                      )
                    }
                    // onBlur={formik.handleBlur}
                    // helperText={getFieldError(index, 'amount')}
                    // error={Boolean(getFieldError(index, 'amount'))}
                  />

                  <IconButtonField
                    sx={{ height: '50px !important', width: '50px !important' }}
                    onClick={() =>
                      removeParkingSlot(index, selectedParkingType)
                    }>
                    <SvgIcon
                      component={Cancel}
                      inheritViewBox
                    />
                  </IconButtonField>
                </div>
              )
            )}
        </div>
      ))}

      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default MasterForm;

const initialValues = {} as ITariffList;
